import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { HostBinding } from '@angular/core';
import { checkIsWebView } from '../../../../helpers/screen-utils';


@Component({
  standalone: true,
  imports: [
    RouterModule
  ],
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
    @Input() showBackButton: boolean = false;
    @Input() backLink: string = '';
    @Input() backLabel: string = '';
    @Input() whiteMobileHeader = false;
    @Output() backClick = new EventEmitter<void>();

    isWebView = false;

    constructor(private router: Router) {}

    ngOnInit(): void {
      this.checkScreen();
    }

    @HostListener('window:resize')
    checkScreen() {
      this.isWebView = checkIsWebView();
    }

    onBackClick(): void {
      this.backClick.emit();
      if (this.backLink) {
        this.router.navigateByUrl(this.backLink);
      }
    }
    @Input() headerIsBackLink = false;

    @HostBinding('class.has-back-button') get hostHasBackButton() {
      return this.showBackButton;
    }

    @HostBinding('class.white-mobile') get hostWhiteMobile() {
      return this.whiteMobileHeader;
    }
 }

